import { BB_OPEN_URL, WebViewOpenUrlMethod } from '../constants/webViewOpenUrl'
import { postHostPayload } from './reactNativeWebView'

/** Ask RN/iframe host to open an external URL (see useWebViewOpenUrlMessage). */
export function postWebViewOpenUrlMessage(
  url: string,
  method: WebViewOpenUrlMethod,
): boolean {
  return postHostPayload({
    method,
    type: BB_OPEN_URL,
    url,
  })
}

/**
 * Opens `url` via the RN/iframe host when embedded, otherwise uses the browser.
 * Returns true when the host accepted the message (caller should skip extra navigation).
 */
export function openUrlOrNotifyHost(
  url: string,
  method: WebViewOpenUrlMethod,
): boolean {
  if (postWebViewOpenUrlMessage(url, method)) {
    return true
  }

  if (method === 'newtab') {
    window.open(url)
  } else {
    window.location.href = url
  }

  return false
}
